module.exports = "<div class=\"c-form__field\">\n    <input type=\"text\" class=\"c-form__input\" id=\"new-password\" name=\"new-password\" ng-model=\"$ctrl.password\" ng-change=\"$ctrl.checkStrength()\" autocomplete=\"new-password\" ng-minlength=\"8\" ng-maxlength=\"50\" ng-disabled=\"$ctrl.saving\" required />\n    <label class=\"c-form__label\" for=\"new-password\">Account Password</label>\n</div>\n<div class=\"c-strength-meter\">\n    <div class=\"c-strength-meter__fill\" data-strength=\"{{ $ctrl.strength.score || 0 }}\"></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/user/views/password.input.html
// module id = 883
// module chunks = 0